import * as _ from 'lodash';
import * as React from 'react';

function constructList(listItems: (JSX.Element | string)[]) {
  return <ul>{_.map(listItems, (listItem, i) => <li key={i}>{listItem}</li>)}</ul>;
}

const rewardsProgramLink = 'https://www.macu.com/accounts/checking/mystyle-checking#rewards';

export const myStyleDetails = (
  <div>
    {constructList([
      <div>
        Extensive{' '}
        <a href={rewardsProgramLink} target="_blank">
          rewards program
        </a>{' '}
        including travel rebates, cash back, gift cards, and more¹
      </div>,
      '0.25 percent discount on auto, RV and personal loans',
      'No minimum balance to open the account',
      'Free access to your FICO® Score²',
    ])}
    <p>
      <b>Waive the fee</b>
    </p>
    <p>
      Take <b>one</b> of these actions, and we'll waive the monthly $4 maintenance fee:
    </p>
    {constructList([
      'Make at least $1,000 in direct deposits each month.',
      'Perform at least 10 credit and/or debit card transactions each month.',
      'Maintain an average daily balance of at least $2,500 for the month.',
    ])}
  </div>
);

export const myFreeDetails = constructList([
  'No minimum balance requirements',
  'No fees or hidden restrictions',
  'Online and mobile banking with eStatements¹',
  'Mountain America Visa® debit cards',
  'Free access to your FICO® Score²',
]);

export const traditionalSavingsDetails = constructList([
  'Only $5 to open an account',
  'Requires an average daily balance of $5',
  'Earn dividends on $100 or more',
  'No monthly service fees',
  'Insured up to at least $250,000 by NCUA',
]);
